import React from 'react';

import logger from 'src/clients/LoggingClient';
import { Domain, fetch } from 'src/clients/Network/http/fetch';
import { Event, track } from 'src/clients/tracking';

const hashSHA256 = async (input: string): Promise<string> => {
  try {
    const buffer = Buffer.from(input);
    const hashedBuffer = await crypto.subtle.digest('SHA-256', buffer);
    return Array.prototype.map.call(new Uint8Array(hashedBuffer), (x) => `00${x.toString(16)}`.slice(-2)).join('');
  } catch (_) {
    return 'unknown'; // `crypto` is undefined on http, ie11, so have a fallback
  }
};

export type IdentiAgreement = {
  id: string;
  isLoading: boolean;
  sha256: string;
  text: string;
};

// Copied from https://github.com/robinhoodmarkets/rh/blob/ac72a25851b1c912511d941f4d194d821b1f2977/web/web-app/src/general/hooks/useIdentiAgreement.tsx#L15
export function useIdentiAgreement({ type }: { type: string }): IdentiAgreement {
  const [id, setId] = React.useState('');
  const [text, setText] = React.useState('');
  const [sha256, setSha256] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    const cb = async () => {
      setIsLoading(true);
      try {
        const res = await fetch(Domain.RHIdenti, `/user_info/agreements/v2/retrieve/${type}/`);
        if (res.status === 200) {
          const json = await res.json();
          if (json.cdn_url) {
            const agreementResponse = await global.fetch(json.cdn_url);
            if (agreementResponse.ok) {
              const responseText = await agreementResponse.text();
              setSha256(await hashSHA256(responseText));
              setId(json.id);
              setText(responseText);
            }
          }
        }
      } catch (e) {
        logger.error(e, { source: 'useIdentiAgreement' });
        track(Event.IdentiAgreementFetchError, { type });
      } finally {
        setIsLoading(false);
      }
    };
    cb();
  }, [type]);

  return { id, isLoading, sha256, text };
}
